export enum UserRole {
    Manager = 'Manager',
    Panellist = 'Panellist',
    Recruiter = 'Recruiter',
    Admin = 'Admin',
    SuperAdmin = 'SuperAdmin',
    HRHead = 'HRHead',
    External = 'External',
    Employee = 'Employee',
    TalentManager = 'TalentManager',
    TalentLead = 'TalentLead',
}
